import React from "react";
import Table from "~/components/old-table";
import TitledCard from "~/components/titled-card";
import TableCell from "~/components/old-table-cell";
import TableContent from "~/components/old-table-content";
import { FieldOffice } from "~/gql/types";
import TableHeader from "~/components/old-table-header";
import Spinner from "~/components/spinner";
import _ from "lodash";
import "./FieldOfficeList.scss";
import { useBreadcrumbs } from "~/main-layout/BreadcrumbProvider";
import { fieldOffices } from "~/routes";
import { LinkClickHandler } from "~/link-click-handler";

const FieldOfficeRow: React.FC<{ data: FieldOffice }> = ({ data }) => {
  const path = `${fieldOffices.path}/${data.officeCode}`;

  return (
    <LinkClickHandler path={path}>
      <TableCell>{data.officeCode}</TableCell>
      <TableCell>{data.allowsProjects ? "Yes" : "No"}</TableCell>
    </LinkClickHandler>
  );
};

export type FieldOfficeListProps = {
  fieldOffices: FieldOffice[];
  isLoading: boolean;
};

const FieldOfficeList: React.FC<FieldOfficeListProps> = ({
  fieldOffices,
  isLoading,
}) => {
  useBreadcrumbs([{ text: "Field Offices" }], []);

  const orderedFieldOffices = _.chain(fieldOffices)
    .orderBy((x) => x.officeCode)
    .value();

  return (
    <div className="field-offices">
      <Spinner open={isLoading} />

      <TitledCard title="Field Office Codes">
        <Table compact>
          <TableHeader>
            <TableCell text="Office code" />
            <TableCell text="Allows projects" />
          </TableHeader>
          {orderedFieldOffices.map((fieldOffice, idx) => (
            <TableContent
              key={idx}
              trailingSeparator={idx !== fieldOffices.length - 1}
              className="field-office"
            >
              <FieldOfficeRow data={fieldOffice} />
            </TableContent>
          ))}
        </Table>
      </TitledCard>
    </div>
  );
};

export default FieldOfficeList;
